import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './navbar';

const RoleBlock = ({ title, color }) => (
  <div className={`w-full p-6 mb-4 rounded-lg shadow-md ${color}`}>
    <h2 className="text-xl font-bold text-white text-center">{title}</h2>
  </div>
);

const ResponsiveRoleBlocks = () => {
  return (
    <div className="min-h-screen bg-amber-50">
      {/* Navbar positioned at the top */}
      <Navbar />

      {/* Content positioned below the navbar */}
      <div className="flex items-center justify-center pt-16">
        <div className="w-full max-w-md px-4">
          <div className="flex flex-col space-y-4">
            <Link to="/super_signup">
              <RoleBlock title="Super Admin" color="bg-amber-500" />
            </Link>
            <Link to="/manager_login">
              <RoleBlock title="Manager" color="bg-amber-500" />
            </Link>
            <Link to="/login">
              <RoleBlock title="Employee" color="bg-amber-500" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveRoleBlocks;
